// 主题配置文件
const theme = {
  colors: {
    primary: '#ff6b9d',
    secondary: '#8a6bff',
    background: {
      main: '#1f1f38',
      secondary: '#151529'
    },
    text: {
      primary: '#ffffff',
      secondary: '#d4d4ff'
    }
  },
  fonts: {
    main: "'Poppins', sans-serif"
  },
  spacing: {
    xs: '0.5rem',
    sm: '1rem',
    md: '1.5rem',
    lg: '2rem',
    xl: '3rem'
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '16px',
    full: '50%'
  },
  shadows: {
    sm: '0 2px 4px rgba(0, 0, 0, 0.1)',
    md: '0 4px 8px rgba(0, 0, 0, 0.1)',
    lg: '0 8px 16px rgba(0, 0, 0, 0.1)'
  },
  transitions: {
    default: '0.3s ease'
  }
};

export { theme }; 